import { Slider } from "@/components/ui/slider";

const FIBONACCI = [1, 2, 3, 5, 8, 13, 21];

const LABELS: Record<number, string> = {
  1: "Trivial",
  2: "Small",
  3: "Medium",
  5: "Large",
  8: "XL",
  13: "XXL",
  21: "Epic",
};

interface Props {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}

export function EffortSelector({ value, onChange, disabled }: Props) {
  const index = FIBONACCI.indexOf(value) === -1 ? 2 : FIBONACCI.indexOf(value);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center gap-3">
        <span className="flex size-8 items-center justify-center bg-primary/10 text-primary text-sm font-bold tabular-nums">{value}</span>
        <div>
          <p className="text-sm font-medium">{LABELS[value]}</p>
          <p className="text-xs text-muted-foreground">Story points</p>
        </div>
      </div>
      <Slider min={0} max={FIBONACCI.length - 1} step={1} value={[index]} onValueChange={([i]) => onChange(FIBONACCI[i])} disabled={disabled} className="w-full [&_[data-slot=slider-thumb]]:cursor-pointer" />
      <div className="flex justify-between">
        {FIBONACCI.map((pt) => (
          <button
            key={pt}
            type="button"
            onClick={() => onChange(pt)}
            disabled={disabled}
            className={`flex size-7 items-center justify-center text-[10px] font-semibold tabular-nums transition-colors
              ${value === pt ? "bg-primary text-primary-foreground" : "bg-muted text-muted-foreground hover:bg-accent hover:text-foreground"}
              ${disabled ? "pointer-events-none opacity-50" : ""}`}
          >
            {pt}
          </button>
        ))}
      </div>
    </div>
  );
}
